import { render, staticRenderFns } from "./OutputStatistic.vue?vue&type=template&id=ba16b914"
import script from "./OutputStatistic.vue?vue&type=script&lang=ts"
export * from "./OutputStatistic.vue?vue&type=script&lang=ts"
import style0 from "./OutputStatistic.vue?vue&type=style&index=0&id=ba16b914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports